// extracted by mini-css-extract-plugin
export default {"page":"Sfa-z","cartModal":"Tfa-z","checkout":"Ufa-z","placeholder":"Vfa-z","account":"Wfa-z"};